import AdManager from "./ad-manager"
import Script from "./script"

class Viralize extends Script {
  constructor(settings) {
    super({
      zidSafe: null,
      zidSafeFloating: null,
      zidUnsafe: null,
      zidUnsafeFloating: null,
      delay: {
        desktop: false,
        mobile: false,
      },
      ...settings,
    })

    this.delayed = false
    this.floatMode = true
    this.pageIsSafe =
      document.body.hasAttribute("data-unsafe") &&
        document.body.dataset.unsafe === "1"
        ? false
        : true
    this.settings.zid = null
    this.customParams = ""

    // Get UTMs
    this.utms = AdManager.prototype.getUTMs()

    // Main container for players, if exists use it else create it and append it to the body
    this.mainContainer = document.querySelector("#_galaxy-video")
    if (!this.mainContainer) {
      this.mainContainer = document.createElement("div")
      this.mainContainer.id = "_galaxy-video"
      this.mainContainer.dataset.float = "true"
      document.body.appendChild(this.mainContainer)
    }

    if (!!this.mainContainer) {
      // Set float mode False if main container has data-float="false"
      if (
        this.mainContainer.hasAttribute("data-float") &&
        this.mainContainer.dataset.float === "false"
      ) {
        this.floatMode = false
        this._debugger("viralize", "Floating mode disabled")
      }

      // Set zid based on float mode and page safety
      if (this.floatMode) {
        this.settings.zid = this.settings.zidSafeFloating
        if (!this.pageIsSafe) {
          if (this.settings.zidUnsafeFloating) {
            this.settings.zid = this.settings.zidUnsafeFloating
          } else {
            this._debugger(
              "viralize",
              "Unsafe page detected but no unsafe ZID provided for floating mode",
              null,
              "error"
            )
          }
        }
      } else {
        this.settings.zid = this.settings.zidSafe
        if (!this.pageIsSafe) {
          if (this.settings.zidUnsafe) {
            this.settings.zid = this.settings.zidUnsafe
          } else {
            this._debugger(
              "viralize",
              "Unsafe page detected but no unsafe ZID provided for non-floating mode",
              null,
              "error"
            )
          }
        }
      }

      // Check if zid is set and if not throw an error
      if (!this.settings.zid) {
        this._debugger(
          "viralize",
          `No ZID provided for ${this.floatMode ? "floating" : "non-floating"
          } mode`,
          null,
          "error"
        )
        return
      }

      // If current device is mobile and delay is enabled for mobile, set delayed to true
      if (
        this.settings.delay.mobile === true &&
        window.galaxyNetworkInserter.isMobile === "1"
      ) {
        this.delayed = true
        this._debugger("viralize", "Delayed load enabled for mobile")
      }

      // If current device is desktop and delayed is enabled for desktop, set delayed to true
      if (
        this.settings.delay.desktop === true &&
        window.galaxyNetworkInserter.isMobile === ""
      ) {
        this.delayed = true
        this._debugger("viralize", "Delayed load enabled for desktop")
      }

      this.mainContainer.dataset.delayed = this.delayed

      // Check if autoreload is overriden by main container data-autoreload
      if (
        this.mainContainer.hasAttribute("data-autoreload") &&
        this.mainContainer.dataset.autoreload !== ""
      ) {
        this.settings.autoreload = parseInt(
          this.mainContainer.dataset.autoreload
        )
        this._debugger(
          "viralize",
          `Autoreload overriden by main container to ${this.settings.autoreload}`
        )
      }

      // Trigger custom event to notify that the main container is ready
      document.dispatchEvent(
        new CustomEvent("viralize:mainContainerReady", {
          detail: { mainContainer: this.mainContainer },
        })
      )
      this._debugger("viralize", "viralize:mainContainerReady dispatched")
    }
  }

  load(auction) {
    let url = new URL(
      "https://content.viralize.tv/display/?zid=" +
      this.settings.zid +
      "&u=" +
      encodeURIComponent(window.location.href.split("?")[0])
    )
    let bids = Object.values(auction)
      .filter((item) => item)
      .join("")
    let pubCustParams = new Array()
    if (this.utms) {
      Object.keys(this.utms).forEach((key) => {
        pubCustParams.push(`${key.toLocaleUpperCase()}=${this.utms[key]}`)
      })
    }
    if (bids) pubCustParams.push(bids)
    if (this.customParams) pubCustParams.push(this.customParams)
    url.searchParams.set("pub_cust_params", pubCustParams.join("&"))
    url = url.toString()
    if (this.settings.schain) {
      // Add schain here because searchParams encode the value and Viralize doesn't like it
      url += `&schain=${this.settings.schain}`
    }
    if (this.mainContainer.dataset.delayed === "true") {
      let observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          this._debugger(
            "viralize",
            "The " + mutation.attributeName + " attribute was modified."
          )
          if (
            mutation.type === "attributes" &&
            mutation.attributeName == "data-delayed"
          ) {
            this.inject(url)
            this._debugger("viralize", "done delayed load()")
            observer.disconnect()
          }
        }
      })
      observer.observe(this.mainContainer, {
        attributes: true,
        childList: false,
      })
    } else {
      this.inject(url)
      this._debugger("viralize", "done load()")
    }
  }

  inject(url) {
    const script = document.createElement("script")

    this._debugger("viralize url", url)

    // Remove previous loaded players
    while (this.mainContainer.firstChild) {
      this.mainContainer.removeChild(this.mainContainer.firstChild)
    }

    script.src = url.toString()
    script.dataset.wid = "auto"
    this.mainContainer.appendChild(script)

    this._debugger("viralize", "done inject()")
  }
}

export default Viralize
